<template>
  <div :id="componentId" class="spm1-core" :style="{ backgroundColor }">
    <div
      v-for="(activity, idx) in activities"
      :key="idx"
      class="spm1-core-item"
    >
      <div class="spm1-core-tag-bar">
        <span class="spm1-core-tag">{{ singleLine(activity.tag) }}</span>
      </div>
      <div class="spm1-core-content">
        <div class="spm1-core-title-wrap">
          <div class="spm1-core-divider"></div>
          <span class="spm1-core-title">{{ singleLine(activity.title) }}</span>
        </div>
        <div class="spm1-core-date-block">
          <span class="spm1-core-date-label">发布时间</span>
          <span class="spm1-core-date-value">{{ activity.dateRange }}</span>
        </div>
        <div class="spm1-core-date-block">
          <span class="spm1-core-date-label">发布时间</span>
          <span class="spm1-core-date-value">{{ activity.date }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileCoreActivities',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_10'
    }
  },
  data() {
    return {
      backgroundColor: 'rgba(255, 255, 255, 1)',
      activities: [
        {
          tag: '一场发展远鉴\n趋势论坛',
          title: '2026区域农业品牌\n发展论坛',
          dateRange: '8月—11月',
          date: '12月20日'
        },
        {
          tag: '一部权威年度\n发展报告',
          title: '2026中国区域农业\n品牌发展报告',
          dateRange: '8月—11月',
          date: '12月20日'
        },
        {
          tag: '一场发展远鉴\n趋势论坛',
          title: '2026区域农业品牌\n发展论坛',
          dateRange: '8月—11月',
          date: '12月20日'
        },
        {
          tag: '一场发展远鉴\n趋势论坛',
          title: '2026区域农业品牌\n发展论坛',
          dateRange: '8月—11月',
          date: '12月20日'
        },
        {
          tag: '一场发展远鉴\n趋势论坛',
          title: '2026区域农业品牌\n发展论坛',
          dateRange: '8月—11月',
          date: '12月20日'
        }
      ]
    }
  },
  methods: {
    singleLine(text) {
      return text.replace(/\n/g, '')
    }
  }
}
</script>

<style scoped>
.spm1-core {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.spm1-core-item + .spm1-core-item {
  margin-top: 12px;
}

.spm1-core-tag-bar {
  width: 100%;
  height: 40px;
  background-image: linear-gradient(90deg, rgba(43, 131, 120, 1) 0, rgba(48, 133, 122, 0) 100%);
  display: flex;
  align-items: center;
  padding: 0 12px;
  box-sizing: border-box;
}

.spm1-core-tag {
  font-size: 15px;
  color: rgba(255, 255, 255, 1);
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.spm1-core-content {
  display: grid;
  grid-template-columns: 1fr 76px 76px;
  align-items: center;
  gap: 8px;
  background-color: rgba(243, 246, 243, 1);
  padding: 12px;
  box-sizing: border-box;
}

.spm1-core-title-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.spm1-core-divider {
  flex-shrink: 0;
  width: 20px;
  height: 4px;
  border-radius: 2px;
  background-color: rgba(56, 138, 128, 1);
}

.spm1-core-title {
  font-size: 13px;
  color: #000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.spm1-core-date-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.spm1-core-date-label {
  font-size: 10px;
  color: rgba(102, 102, 102, 1);
  white-space: nowrap;
}

.spm1-core-date-value {
  font-size: 13px;
  color: rgba(45, 132, 121, 1);
  font-weight: 500;
  white-space: nowrap;
}
</style>
